/* MISE PDP enhancements: EU/US size toggle, size-required nudge */
(function () {
  'use strict';
  if (window.__misePdpEnh) return;
  window.__misePdpEnh = true;

  // Official MISE size chart (matches the size guide modal): EU -> [US Men's, US Women's]
  var MAP = {
    '37': ['4.5', '6'],
    '38': ['5–5.5', '6.5–7'],
    '39': ['6–6.5', '7.5–8'],
    '40': ['7', '8.5'],
    '41': ['7.5–8', '9–9.5'],
    '42': ['8.5', '10'],
    '43': ['9–9.5', '10.5–11'],
    '44': ['10', '11.5'],
    '45': ['10.5–11', '12–12.5'],
    '46': ['11.5–12', '13–13.5'],
    '47': ['12.5', '14'],
    '48': ['13–13.5', '14.5–15'],
    '49': ['14–14.5', '15.5–16']
  };
  var UNITS = ['eu', 'us-m', 'us-w'];
  // Always start on EU (the choice is not remembered between pages)
  var unit = 'eu';

  function labelFor(eu, u) {
    var row = MAP[eu];
    if (u === 'eu' || !row) return eu;
    return u === 'us-m' ? row[0] : row[1];
  }

  function fullName(eu) {
    var row = MAP[eu];
    if (!row) return 'EU ' + eu;
    return 'EU ' + eu + ', US Men’s ' + row[0] + ', US Women’s ' + row[1];
  }

  function render() {
    var inputs = document.querySelectorAll('input[data-size-eu]');
    if (!inputs.length) return;
    inputs.forEach(function (input) {
      var eu = input.getAttribute('data-size-eu');
      var span = input.parentElement && input.parentElement.querySelector('[data-size-label]');
      if (span) span.textContent = labelFor(eu, unit);
      input.setAttribute('aria-label', fullName(eu));
    });
    document.querySelectorAll('[data-size-unit]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-size-unit') === unit ? 'true' : 'false');
    });
  }

  function announce(msg) {
    var el = document.getElementById('screen-reader-info');
    if (!el) return;
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 30);
  }

  function sizeWrapper() {
    var input = document.querySelector('input[data-size-eu]') ||
      document.querySelector('product-variants[data-main-product-variants] input[type="radio"][name*="size" i]');
    return input ? input.closest('.product-variant') : null;
  }

  function sizeRequired() {
    var pv = document.querySelector('product-variants[data-main-product-variants][data-required-text]');
    return !!(pv && pv.noVariantSelectedYet !== false);
  }

  var nudgeTimer;
  function nudge() {
    var wrap = sizeWrapper();
    if (!wrap) return;
    var rect = wrap.getBoundingClientRect();
    if (rect.top < 60 || rect.bottom > window.innerHeight - 60) {
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    var msg = wrap.querySelector('.size-required-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'size-required-msg';
      msg.setAttribute('role', 'alert');
      var container = wrap.querySelector('[data-js-product-variant-container]');
      container.insertAdjacentElement('afterend', msg);
    }
    msg.textContent = 'Please select a size to add to cart.';
    wrap.classList.remove('is-nudging');
    void wrap.offsetWidth;
    wrap.classList.add('is-nudging');
    clearTimeout(nudgeTimer);
    nudgeTimer = setTimeout(function () { wrap.classList.remove('is-nudging'); }, 700);
    announce('Please select a size to add to cart.');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-size-unit]');
    if (btn) {
      var next = btn.getAttribute('data-size-unit');
      if (UNITS.indexOf(next) > -1) {
        unit = next;
        render();
      }
      return;
    }
    // Disabled buttons swallow pointer events, so the tap lands on the wrapper.
    var wrapper = e.target.closest && e.target.closest('.product-actions .flex-buttons');
    if (wrapper && sizeRequired()) nudge();
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[data-size-eu]')) {
      render();
      var wrap = t.closest('.product-variant');
      var msg = wrap && wrap.querySelector('.size-required-msg');
      if (msg) msg.remove();
    }
  });

  document.addEventListener('mise:size-required', nudge);

  // Keep the Add to cart button honest while a size is still required.
  // (The theme resets its text to "Select options" whenever a color changes.)
  function syncAddToCart() {
    var pv = document.querySelector('product-variants[data-main-product-variants][data-required-text]');
    if (!pv) return;
    var btn = document.querySelector('[data-main-product-add-to-cart]');
    if (!btn) return;
    var txt = btn.querySelector('[data-js-product-add-to-cart-text]');
    if (pv.noVariantSelectedYet !== false) {
      if (txt) txt.textContent = pv.getAttribute('data-required-text');
      btn.classList.add('disabled');
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
    }
  }
  var pvEl = document.querySelector('product-variants[data-main-product-variants][data-required-text]');
  if (pvEl) pvEl.addEventListener('VARIANT_CHANGE', syncAddToCart);

  // Belt and braces: never let a submit through while a size is required.
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product-actions') && sizeRequired()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      nudge();
    }
  }, true);

  // Preorder pill: pin it to the bottom-left of the main image window so it stays
  // put while shoppers swipe. It renders just before the gallery slider, and
  // css-slider rebuilds its own markup on init, so the pill is moved into the
  // slider's non-scrolling viewport once the slider is ready (or into the image
  // itself when there is only one). CSS keeps it hidden until it's placed.
  function placePreorderPill() {
    var pill = document.querySelector('.preorder-tag--pdp');
    if (!pill) return;
    var gallery = pill.closest('[data-js-product-gallery]') || document;
    var slider = gallery.querySelector('css-slider');
    function place() {
      var target = slider
        ? slider.querySelector('.css-slider-viewport')
        : gallery.querySelector('.product-gallery-item');
      if (!target) return;
      target.appendChild(pill);
      pill.classList.add('is-placed');
    }
    if (slider) slider.addEventListener('ready', place);
    place();
  }

  function init() {
    render();
    placePreorderPill();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
